{
  "id": "campaign-121",
  "name": "Cup Park",
  "seed": "campaign:121",
  "startDir": "E",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    "r...,QQQQ....r",
    "..:,.,.....:..",
    "..:#,.x....:..",
    "..::::::::::..",
    ".#..x....~~~#.",
    "...q..x.~.q...",
    "..x....~~.....",
    "::::::::::::::",
    "x......x.#...x",
    "...q......q...",
    "...#..#.......",
    "..::::::::::..",
    ".x:.x......:..",
    "..:........:..",
    "S....QQQQ....."
  ],
  "critters": [
    {
      "kind": "squirrel",
      "x": 5,
      "y": 8
    },
    {
      "kind": "squirrel",
      "x": 13,
      "y": 12
    },
    {
      "kind": "rabbit",
      "x": 3,
      "y": 0
    },
    {
      "kind": "squirrel",
      "x": 7,
      "y": 10
    },
    {
      "kind": "squirrel",
      "x": 9,
      "y": 3
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 10,
      "y": 6
    },
    {
      "kind": "gas",
      "x": 3,
      "y": 12
    },
    {
      "kind": "coin",
      "x": 8,
      "y": 6
    },
    {
      "kind": "coin",
      "x": 11,
      "y": 4
    },
    {
      "kind": "coin",
      "x": 9,
      "y": 4
    },
    {
      "kind": "coin",
      "x": 2,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 1,
      "y": 0
    },
    {
      "kind": "coin",
      "x": 0,
      "y": 5
    },
    {
      "kind": "repair",
      "x": 5,
      "y": 5
    }
  ],
  "moles": {
    "hills": 4,
    "first": 30,
    "every": 20
  },
  "generatorVersion": 3,
  "level": 121,
  "biome": "stadium",
  "par": {
    "reel": 7097,
    "push": 6151,
    "selfPropelled": 5712,
    "tractor": 4640,
    "zeroTurn": 3863,
    "fairway": 2532
  },
  "goldTime": {
    "reel": 7097,
    "push": 6008,
    "selfPropelled": 5568,
    "tractor": 4640,
    "zeroTurn": 3863,
    "fairway": 2532
  },
  "routeTries": {
    "par": {
      "reel": 0,
      "push": 19,
      "selfPropelled": 6,
      "tractor": 0,
      "zeroTurn": 7,
      "fairway": 23
    },
    "gold": {
      "reel": 0,
      "push": 29,
      "selfPropelled": 34,
      "tractor": 0,
      "zeroTurn": 7,
      "fairway": 23
    }
  }
}
